import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PropertiesInterface } from 'app/interface/properties';
import { PropertyInterface } from 'app/interface/property';
import { MFYardiProperty } from 'app/models/mfYardiProperty';
import { Property } from 'app/models/property';
import { PropertyFavorite } from 'app/models/property-favorite';
import { PropertyViewCard } from 'app/models/property-view-card';
import { forkJoin, Observable } from 'rxjs';
import { ApplicationDataService } from 'services/application.service';
import { ErrorService } from 'services/error.service';
import { FavoriteService } from 'services/favorite.service';

interface SortOption {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-fav-dashboard',
  templateUrl: './fav-dashboard.component.html',
  styleUrls: ['./fav-dashboard.component.css']
})
export class FavDashboardComponent implements OnInit {
  options: SortOption[] = [
    {value: 'p-lh', viewValue: 'Price: Low to High'},
    {value: 'p-hl', viewValue: 'Price: High to Low'},
    {value: 'b-hl', viewValue: 'Bedrooms: High to Low'},
    {value: 'b-lh', viewValue: 'Bedrooms: Low to High'},
    {value: 'sf-hl', viewValue: 'Square Footage: High to Low'},
    {value: 'sf-lh', viewValue: 'Square Footage: Low to High'}
  ];
  selectedOption = this.options[0].value;
  favoriteCount: number = 0;
  favorites: PropertyFavorite[] = [];
  mfFavorites: PropertyFavorite[] = [];
  allFavorites: PropertyFavorite[] = [];
  availableProperties: Property[] = [];
  observeArray: Observable<PropertiesInterface>[] = [];
  observeMFArray: Observable<PropertiesInterface>[] = [];
  observablePropObj: {sfProps: Observable<PropertiesInterface>, mfProps: Observable<PropertiesInterface>} = {mfProps: null, sfProps: null};
  showButtons: boolean = false;
  viewMap: boolean = false;
  mapLocations: string[] = [];
  mfMapLocations: MFYardiProperty[] = [];


  constructor(private favoriteService: FavoriteService, private applicationService: ApplicationDataService, private errorService: ErrorService, private router: Router) {
    this.favoriteService.getFavorites().subscribe(res => this.onGetFavorites(res), err => this.errorService.showError(err));
    this.observablePropObj = {mfProps: this.applicationService.getPublishedMFPropertyList(), sfProps: this.applicationService.getProperties()};
   }

  ngOnInit(): void {}

  onGetAvailableProperties(properties: {sfProps: PropertiesInterface, mfProps: PropertiesInterface})
  {
    if (properties.sfProps.results || properties.mfProps.results)
    {
      if(properties.sfProps.results){
        this.availableProperties = properties.sfProps.results.concat(properties.mfProps?.results ?? []);
      }
      else {
        this.availableProperties =properties.mfProps.results;
      }

      for (const fav of this.favorites)
      {
        if (!this.availableProperties.some(b => fav.PropertyViewCard.unit_code === b.unit_code))
        {
          fav.Leased = true;
          fav.BannerText = "LEASED"
        }

      }

      this.options.push({value: 'available', viewValue: 'Available'});
    }

    this.showButtons = true;
  }

  sortFavorites()
  {
    if (!this.allFavorites.length)
    {
      this.allFavorites = this.favorites;
    }

    this.favorites = this.allFavorites;

    if (this.selectedOption === "p-lh")
    {
      this.favorites.sort((a, b) => (a.PropertyViewCard.rentValue > b.PropertyViewCard.rentValue) ? 1 : -1);
    }
    else if (this.selectedOption === "p-hl")
    {
      this.favorites.sort((a, b) => (a.PropertyViewCard.rentValue < b.PropertyViewCard.rentValue) ? 1 : -1);
    }
    else if (this.selectedOption === "b-lh")
    {
      this.favorites.sort((a, b) => (a.PropertyViewCard.beds > b.PropertyViewCard.beds) ? 1 : -1);
    }
    else if (this.selectedOption === "b-hl")
    {
      this.favorites.sort((a, b) => (a.PropertyViewCard.beds < b.PropertyViewCard.beds) ? 1 : -1);
    }
    else if (this.selectedOption === "sf-lh")
    {
      this.favorites.sort((a, b) => (a.PropertyViewCard.sqftValue > b.PropertyViewCard.sqftValue) ? 1 : -1);
    }
    else if (this.selectedOption === "sf-hl")
    {
      this.favorites.sort((a, b) => (a.PropertyViewCard.sqftValue < b.PropertyViewCard.sqftValue) ? 1 : -1);
    }
    else if (this.selectedOption === "available")
    {
      this.favorites = this.favorites.filter(a => this.availableProperties.some(b => a.PropertyViewCard.unit_code === b.unit_code));
    }
  }

  onGetFavorites(favs: PropertyFavorite[])
  {
    this.favoriteCount = favs.length;

    for(const element of favs){
      if(element.IsMF){
        this.applicationService.getMFProperty(element.YardiKey, element.YardiUnitCode).subscribe(res => this.onGetProperty(res, element), err => this.errorService.showError(err));
        this.mfMapLocations.push({YardiKey: element.YardiKey, YardiUnitCode: element.YardiUnitCode});
      } else {
        this.applicationService.getProperty(element.YardiKey).subscribe(res => this.onGetProperty(res, element), err => this.errorService.showError(err));  
        this.mapLocations.push(element.YardiKey);
      }
    }
  }

  onGetProperty(prop: PropertyInterface, fav: PropertyFavorite)
  {
    let newPropCard = new PropertyViewCard();

    if (prop.results && prop.results[0])
    {
      newPropCard = { ...prop.results[0], sqft: `${prop.results[0].sqft}` };
      if(fav.IsMF){
        newPropCard.street = newPropCard.street + ` Unit ${newPropCard.unit_code}`;
      }

      if ((newPropCard.min_rent != null && newPropCard.max_rent != null) && (newPropCard.min_rent == newPropCard.max_rent)) {
        newPropCard.rent = newPropCard.min_rent.toLocaleString().toLocaleString();
        newPropCard.rentValue = Number(newPropCard.min_rent);
      }
      else if (newPropCard.min_rent != null && newPropCard.max_rent != null) {
        newPropCard.rent = prop.results[0].min_rent.toLocaleString() + '-$'+ newPropCard.max_rent.toLocaleString();
        newPropCard.rentValue = Number(newPropCard.min_rent);
      }
      else {
        newPropCard.rentValue = Number(newPropCard.rent);
        newPropCard.rent = newPropCard?.rent?.toLocaleString();
      }

      newPropCard.sqftValue = Number(newPropCard.sqft);
      newPropCard.sqft = newPropCard.sqft.toLocaleString();
              
      fav.PropertyViewCard = newPropCard;
      fav.Active = true;
      
      if (fav.PropertyViewCard.status === "Notice Unrented" || fav.PropertyViewCard.status === "Vacant Unrented Not Ready")
      {
        fav.BannerText = "COMING SOON";
      }

      if(fav.IsMF){
        this.favoriteService.getActiveMFConcession(fav.YardiKey, fav.YardiUnitCode).subscribe(res => this.onConcessionCheck(res, fav), err => this.errorService.showError(err));
      }
      else{
        this.favoriteService.getActiveConcession(fav.YardiKey).subscribe(res => this.onConcessionCheck(res, fav), err => this.errorService.showError(err));
      }

      
    } else {
      this.favoriteCount--;
    }
  }

  onConcessionCheck(concessionText:string, fav: PropertyFavorite)
  {
    if (concessionText)
    {
      fav.ConcessionText = concessionText;
    }

    this.favorites.push(fav);

    if (this.favorites.length === this.favoriteCount)
    {
      this.sortFavorites();
      forkJoin(this.observablePropObj).subscribe(results => this.onGetAvailableProperties(results), err => this.errorService.showError(err));
    }
  }

  async toggleFavorite(favorite: PropertyFavorite)
  {

    if (!favorite.Updating)
    {
      favorite.Updating = true;

      try {
        if (favorite.Active)
        {
          favorite.Active = false;
          await this.favoriteService.deleteFavorite(favorite.YardiKey, favorite.YardiUnitCode).toPromise();
          
        }
        else{
          favorite.Active = true;
          favorite.Source = "";
          let source = localStorage.getItem('Source');
  
          if (source !== null && source !== undefined)
          {
            favorite.Source = source;
          }
          await this.favoriteService.createFavorite(favorite).toPromise();        
        }
      }
      catch (error)
      {
        this.errorService.showError("Error updating favorite.");     
      }

      favorite.Updating = false;
     
    }    
  }

  toggleMap()
  {
    if (this.viewMap)
    {
      this.viewMap = false;
    }
    else {
      this.viewMap = true;
    }
  }

  viewListing(favorite: PropertyFavorite)
  {
    window.open(
      favorite.PropertyViewCard.link,'_blank');
  }

  applyNow(favorite: PropertyFavorite)
  {
    localStorage.setItem("YardiKey", favorite.YardiKey);
    localStorage.setItem("PropertyYardiKey", favorite.YardiKey);

    if(favorite.IsMF){
      localStorage.setItem("mfunitcode", favorite.YardiUnitCode)
    }
    this.router.navigate(['application/landing']);
  }

}
